














import Vue from 'vue'

import AppForm from '@/components/app/AppForm.vue'

export default Vue.extend({
  name: "admin-page",
  components: { AppForm },

  computed: {
    accountFields():FormField[] {
      let fields
      if (this.$store.state.user.userType == "client") {
        fields = Object.entries(this.$store.state.schemas.clients || {}).map(([key, value]) => {
          const field:any = {}
          return Object.assign(field, {key, ...value})
        })
      } else if (this.$store.state.user.userType == "partner") {
        fields = Object.entries(this.$store.state.schemas.partners || {}).map(([key, value]) => {
          const field:any = {}
          return Object.assign(field, {key, ...value})
        })
      } else {
        fields = []
      }
      return fields.filter(field => field.display == "field")
    }
  },

  methods: {
    
  },

  filters: {
    
  },

  created() {

  },
  mounted() {

  },
  updated() {
    
  }
})
